module.exports = __webpack_public_path__ + "media/assets/images/flags/ms-312bd999eef56746ba89c282e0c74ce7.svg";